// Host→host invite copy.
//
// As of 2026-02-22 we ship a single canonical message — no A/B/C variants,
// no per-invite tracking URL. The message points recipients to the root
// domain (`allurexp. com`) so it stays short, unscary, and doesn't trip
// Airbnb chat's link filter. Attribution still works: the internal
// `host_listing_invites` doc is keyed by `listing_id`, so when the owner of
// the invited Airbnb listing signs up we still match them back to the
// inviter and stamp the 2% unlock timer.
//
// The `link` parameter is kept in the signature purely for call-site
// compatibility — it is ignored.

const FALLBACK_GREETING_FIRST_NAME = 'there';

const greetWithName = (firstName) => {
  const cleaned = (firstName || '').trim();
  return cleaned || FALLBACK_GREETING_FIRST_NAME;
};

// The one canonical message. Note the "allurexp. com" — the leading space
// after the dot is intentional: it prevents Airbnb from recognising this
// as a URL and gating the message with its "external link" warning.
const buildCanonicalMessage = ({ firstName }) => (
  `Hey ${greetWithName(firstName)}, fellow Airbnb host here.\n\n` +
  `I use Allure to point my guests to the area’s most standout venues, and I get a small % on whatever they spend.\n\n` +
  `For Airbnb hosts only.\n\n` +
  `allurexp. com`
);

// Retained for legacy telemetry — every invite still carries a `variant`
// field so historical Airbridge funnels don't break. New messages are
// identical across variants.
export const HOST_INVITE_VARIANTS = ['a'];

export function buildHostInviteMessage({ firstName = '' } = {}) {
  return buildCanonicalMessage({ firstName });
}
